import styled from "styled-components";
import LandingHero from "../../assets/LandingHero.jpg";

const HeroSection = () => {
  const handleAvailableProducts = () => {
    window.location.href = "/products";
  };

  const handlePrototypeSprint = () => {
    window.location.href = "/prototype-sprint";
  };

  return (
    <TheHeroSection>
      <div className="overlay"></div>
      <div className="hero-background">
        <img src={LandingHero} alt="landing-background" />
      </div>
      <div className="landing-content">
        <h3>
          Guiding your product from concept to scale with uncompromising clarity
          and compliance.
        </h3>
        <p>
          Medichy enables startups and OEMs to develop and scale medtech
          products faster—without compromising regulatory compliance.
        </p>
        <div className="call-to-action">
          <button className="btn-primary" onClick={handleAvailableProducts}>
            Available Products
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="currentColor"
              viewBox="0 0 16 16"
            >
              <path
                fillRule="evenodd"
                d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
              />
            </svg>
          </button>
          <button className="btn-secondary" onClick={handlePrototypeSprint}>
            Prototype Sprint
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="currentColor"
              viewBox="0 0 16 16"
            >
              <path
                fillRule="evenodd"
                d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
              />
            </svg>
          </button>
        </div>
      </div>
    </TheHeroSection>
  );
};

const TheHeroSection = styled.div`
  width: 100%;
  height: 70vh;
  position: relative;

  .hero-background {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: -1;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .overlay {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: linear-gradient(
      135deg,
      rgba(0, 50, 150, 0.7) 0%,
      rgba(0, 100, 200, 0.4) 100%
    );
  }

  .landing-content {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    color: #fff;
    width: 90%;
    max-width: 1000px;
    padding: 0 1rem;
    z-index: 1;

    h3 {
      font-size: 2.5rem;
      font-weight: 700;
      margin-bottom: 1.5rem;
      text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.3);
      line-height: 1;
    }

    p {
      font-size: 1rem;
      font-weight: 400;
      opacity: 0.95;
      text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);
      margin-bottom: 3rem;
      line-height: 1.6;
      max-width: 800px;
      margin-left: auto;
      margin-right: auto;
    }

    .call-to-action {
      display: flex;
      gap: 2rem;
      justify-content: center;
      flex-wrap: wrap;

      .btn-primary {
        display: inline-flex;
        align-items: center;
        gap: 0.75rem;
        background: white;
        color: #3182ce;
        border: none;
        padding: 1rem 2.5rem;
        font-size: 1.1rem;
        font-weight: 600;
        border-radius: 50px;
        cursor: pointer;
        transition: all 0.3s ease;
        text-transform: uppercase;
        letter-spacing: 0.5px;

        &:hover {
          background: #f7fafc;
          transform: translateY(-2px);
          box-shadow: 0 8px 25px rgba(255, 255, 255, 0.2);

          svg {
            transform: translateX(5px);
          }
        }

        svg {
          transition: transform 0.3s ease;
        }
      }

      .btn-secondary {
        display: inline-flex;
        align-items: center;
        gap: 0.75rem;
        background: transparent;
        color: white;
        border: 2px solid white;
        padding: 1rem 2.5rem;
        font-size: 1.1rem;
        font-weight: 600;
        border-radius: 50px;
        cursor: pointer;
        transition: all 0.3s ease;
        text-transform: uppercase;
        letter-spacing: 0.5px;

        &:hover {
          background: white;
          color: #3182ce;
          transform: translateY(-2px);
          box-shadow: 0 4px 15px rgba(255, 255, 255, 0.2);

          svg {
            transform: translateX(5px);
          }
        }

        svg {
          transition: transform 0.3s ease;
        }
      }
    }
  }

  /* Media Queries */
  @media screen and (max-width: 1366px) {
    height: 70vh;

    .landing-content {
      h3 {
        font-size: 3.25rem;
      }

      p {
        font-size: 1.4rem;
      }

      .call-to-action {
        .btn-primary,
        .btn-secondary {
          padding: 0.875rem 2rem;
          font-size: 1rem;
        }
      }
    }
  }

  @media screen and (max-width: 1200px) {
    height: 70vh;

    .landing-content {
      h3 {
        font-size: 3rem;
      }

      p {
        font-size: 1.3rem;
        margin-bottom: 2.5rem;
      }
    }
  }

  @media screen and (max-width: 900px) {
    height: 70vh;

    .landing-content {
      h3 {
        font-size: 2.5rem;
        margin-bottom: 1.25rem;
      }

      p {
        font-size: 1.1rem;
        margin-bottom: 2rem;
      }

      .call-to-action {
        gap: 1.5rem;

        .btn-primary,
        .btn-secondary {
          padding: 0.75rem 1.75rem;
          font-size: 0.95rem;
        }
      }
    }
  }

  @media screen and (max-width: 600px) {
    height: 100vh;

    .landing-content {
      h3 {
        font-size: 2rem;
        margin-bottom: 1rem;
      }

      p {
        font-size: 1rem;
        margin-bottom: 1.5rem;
      }

      .call-to-action {
        gap: 1rem;

        .btn-primary,
        .btn-secondary {
          padding: 0.625rem 1.5rem;
          font-size: 0.9rem;
        }
      }
    }
  }

  @media screen and (max-width: 420px) {
    height: 100vh;

    .landing-content {
      h3 {
        font-size: 1.75rem;
      }

      p {
        font-size: 0.9rem;
        margin-bottom: 1.25rem;
      }

      .call-to-action {
        flex-direction: column;
        align-items: center;
        gap: 0.75rem;

        .btn-primary,
        .btn-secondary {
          width: 100%;
          max-width: 250px;
          justify-content: center;
          padding: 0.5rem 1.25rem;
          font-size: 0.85rem;
        }
      }
    }
  }

  @media screen and (max-width: 350px) {
    height: 100vh;

    .landing-content {
      h3 {
        font-size: 1.5rem;
      }

      p {
        font-size: 0.85rem;
        margin-bottom: 1rem;
      }

      .call-to-action {
        .btn-primary,
        .btn-secondary {
          padding: 0.5rem 1rem;
          font-size: 0.8rem;

          svg {
            width: 16px;
            height: 16px;
          }
        }
      }
    }
  }
`;

export default HeroSection;
